import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';
import { Status as ClientStatus } from 'store/clients/clientsSlice';

import { NoteForm } from '../NoteForm';
import { FinalizedNoteFormProvider } from '../context';
import { FinalizedEditActions, NoteBodyFields, NoteFields } from './NoteFormSections';

type FinalNoteFormProps = {
  status: ClientStatus | ClientStatus['id'];
  clientId: string;
  clientName: string;
  prependedClientId: string;
  note?: ClientProfileContentItem;
  disabled?: boolean;
  onCancel?: () => void;
  onSubmitSuccess?: () => void;
};

const FinalNoteFormContent = ({ onCancel }: { onCancel?: () => void }) => {
  return (
    <NoteForm.Form>
      <NoteForm.AiScribe.Status />
      <NoteFields expanded />
      <NoteForm.AiScribe.AudioPlayer />
      <NoteBodyFields />
      <FinalizedEditActions onCancel={onCancel} />
    </NoteForm.Form>
  );
};

/**
 * Preset component for editing finalized notes.
 * Used in newNoteView when editing a final note.
 * Has Cancel and Final buttons (no delete or edit).
 * No autosave since this is for finalized notes.
 */
export const FinalNoteForm = ({
  status,
  clientId,
  note,
  clientName,
  prependedClientId,
  disabled = false,
  onCancel,
  onSubmitSuccess
}: FinalNoteFormProps) => {
  return (
    <FinalizedNoteFormProvider
      status={status}
      clientId={clientId}
      note={note}
      disabled={disabled}
      clientName={clientName}
      prependedClientId={prependedClientId}
      onSubmitSuccess={onSubmitSuccess}
    >
      <NoteForm.Root>
        <FinalNoteFormContent onCancel={onCancel} />
      </NoteForm.Root>
    </FinalizedNoteFormProvider>
  );
};
